class ChequesStickyTable {
    constructor(element) {
        if (!element) return

        this.element = element
        this.mainTable = this.element.querySelector('.cheques-sticky-table__main')
        this.stickyTable = this.element.querySelector('.cheques-sticky-table__sticky')

        this.active = false
        this.currentX
        this.initialX
        this.xOffset = 0
        this.tableMaxMove = 0

        this.setStickyTableSize()
        this.setTableMaxMove()
        this.iniDraggableTable()

        window.addEventListener('resize', () => {
            this.setStickyTableSize()
            this.setTableMaxMove()
        })
    }

    setStickyTableSize() {
        this.stickyTable.querySelectorAll('thead tr').forEach((stickyHeadRow, stickyHeadRowIndex) => {
            stickyHeadRow.querySelectorAll('th').forEach((stickyHeadRowCell, stickyHeadRowCellIndex) => {
                const mainHeadRowCell = this.mainTable
                    .querySelectorAll('thead tr')
                    [stickyHeadRowIndex].querySelectorAll('th')[stickyHeadRowCellIndex]
                const mainHeadRowCellRect = mainHeadRowCell.getBoundingClientRect()

                stickyHeadRowCell.style.width = `${mainHeadRowCellRect.width}px`
                stickyHeadRowCell.style.height = `${mainHeadRowCellRect.height}px`
            })
        })

        this.stickyTable.querySelectorAll('tbody tr').forEach((stickyBodyRow, stickyBodyRowIndex) => {
            stickyBodyRow.querySelectorAll('td').forEach((stickyBodyRowCell, stickyBodyRowCellIndex) => {
                const mainBodyRowCell = this.mainTable
                    .querySelectorAll('tbody tr')
                    [stickyBodyRowIndex].querySelectorAll('td')[stickyBodyRowCellIndex]
                const mainBodyRowCellRect = mainBodyRowCell.getBoundingClientRect()

                stickyBodyRowCell.style.width = `${mainBodyRowCellRect.width}px`
                stickyBodyRowCell.style.height = `${mainBodyRowCellRect.height}px`
            })
        })
    }

    setTableMaxMove() {
        const wrapperWidth = this.element.getBoundingClientRect().width
        const mainTableWidth = this.mainTable.scrollWidth

        this.tableMaxMove = (mainTableWidth - wrapperWidth) * -1
    }

    iniDraggableTable() {
        this.mainTable.addEventListener('touchstart', (e) => {
            this.dragStart(e)
        })
        document.addEventListener('touchend', (e) => {
            this.dragEnd(e)
        })
        this.mainTable.addEventListener('touchmove', (e) => {
            this.drag(e)
        })

        this.mainTable.addEventListener('mousedown', (e) => {
            this.dragStart(e)
        })
        document.addEventListener('mouseup', (e) => {
            this.dragEnd(e)
        })
        this.mainTable.addEventListener('mousemove', (e) => {
            this.drag(e)
        })
    }

    dragStart(e) {
        if (e.type === 'touchstart') {
            this.initialX = e.touches[0].clientX - this.xOffset
        } else {
            this.initialX = e.clientX - this.xOffset
        }

        if (e.currentTarget === this.mainTable) {
            this.active = true
        }
    }

    dragEnd() {
        this.initialX = this.currentX

        this.active = false
    }

    drag(e) {
        if (this.active) {
            e.preventDefault()

            if (e.type === 'touchmove') {
                this.currentX = e.touches[0].clientX - this.initialX
            } else {
                this.currentX = e.clientX - this.initialX
            }

            this.xOffset = this.currentX

            const moveOffset = Math.max(Math.min(this.currentX, 0), this.tableMaxMove)

            this.mainTable.style.left = `${moveOffset}px`
        }
    }
}

export default ChequesStickyTable
